import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class HealioSearchBox extends Component {

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {
        if (!$) {
            return;
        }
        let self = this;
        const inputBoxBindingEvent = ['keypress', 'keydown', 'keyup'];

        let searchInput = this._element.querySelector<HTMLInputElement>('#coveodesktopsearchinput,#coveomobilesearchinput')

        inputBoxBindingEvent.forEach(evt => {
            searchInput?.addEventListener(evt,
                (event) => {
                    let keyboardEvent = event as KeyboardEvent;
                    if (keyboardEvent.code.toLocaleLowerCase() === "enter" && ($('#coveodesktopsearchinput').val() || $('#coveomobilesearchinput').val())) {
                        event.preventDefault();
                        self.doSearch();
                    }
                }, false);
        });

        let searchButton = this._element.querySelector<HTMLAnchorElement>('.CoveoSearchButton')

        searchButton?.addEventListener('click', (event) => {
            event.preventDefault();
            self.doSearch();
        })
    }

    private getSearchHost(): string {
        let host = window.location.host
        if (host.indexOf('cmepreview') > -1) {
            if (host.indexOf('qa') > -1) {
                host = 'previewqa.healio.com'
            } else {
                host = 'preview.healio.com'
            }
        }

        if (host.indexOf('cme') > -1) {
            if (host.indexOf('qa') > -1) {
                host = 'qa.healio.com'
            } else if (host.indexOf('ws') > -1) {
                host = 'ws.healio.com'
            } else {
                host = 'www.healio.com'
            }
        }

        if (host.indexOf('h6') > -1) {
            if (host.indexOf('qa') > -1) {
                host = 'previewqa.healio.com'
            } else if (host.indexOf('ws') > -1) {
                host = 'ws.healio.com'
            } else {
                host = 'preview.healio.com'
            }
        }

        return host;
    }

    private doSearch(): void {
        console.log('doing search box search')
        if ($) {
            let queryterm = $("input#coveodesktopsearchinput").val();
            if (queryterm === "")
                queryterm = $("input#coveomobilesearchinput").val();
            if (typeof(queryterm) !== 'string' || queryterm === "") return;
            const host = this.getSearchHost()
            let u = '/search#q=' + encodeURIComponent(queryterm) + '&sort=relevancy';
            if (window.location.href.indexOf("/cme") > -1)
                u += "&f:contenttype=[CME]";
            if (window.location.pathname.indexOf("clinical-guidance") > -1)
                u += "&area=clinicalguidance&f:contenttype=[Clinical Guidance]";
            window.location.href = 'https://' + host + u;
        }
    }
}


ComponentFactory.registerComponent("HealioSearchBox", HealioSearchBox);
